import 'babel-polyfill'
import 'lazysizes'
import Vue from 'vue'
import Buefy from 'buefy'
import './theme/index.scss'

import api from './api'
import i18n from './locales'
import aws from 'shared/aws'
import user from 'shared/user'
import filters from 'shared/filters'
import VueTimeago from 'vue-timeago'
import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto'

import ContentTabs from './components/ContentTabs.vue'
import UserActions from './components/UserActions.vue'
import RatingField from './components/rating/Field.vue'
import CommentList from './components/comment/List.vue'
import TimesTimeline from './components/TimesTimeline.vue'
import LanguageSelect from './components/LanguageSelect.vue'
import PreferredLanguage from './components/PreferredLanguage.vue'


import NavbarDropdown from './components/NavbarDropdown.vue'
import ClientMainMenu from './components/frontend/menu/Main.vue'
import ClientMainMenuNavbar from './components/frontend/menu/Navbar.vue'
import ClientMainMenuMobileToggle from './components/frontend/menu/MobileToggle.vue'
import ClientPanel from './components/panel/Panel.vue'
import ClientPanelExpander from './components/panel/Expander.vue'
import ClientPanelMobileToggle from './components/panel/MobileToggle.vue'
import ClientIngredientList from './components/ingredients/List.vue'
import ClientIngredientServingSelector from './components/ingredients/ServingSelector.vue'
import ClientRecipeList from './components/recipe/List.vue'
import ClientInstructionItem from './components/recipe/InstructionItem.vue'
import ClientInstructionStepByStep from './components/recipe/InstructionStepByStep.vue'
import ClientSearchList from './components/search/List.vue'
import ClientPageSearch from './components/PageSearch.vue'
import ClientInfoMessage from './components/InfoMessage.vue'


// import { Carousel as ContentCarousel, Slide as CarouselSlide } from 'vue-carousel'
import Adsense from 'vue-adsense/VueAdsense.vue'

user.user
.authenticate([])
.then(() => aws.patchAxios(api.api.client))
.catch(() => {}) // ignore

Vue.use(Buefy, {defaultIconPack: 'fa'})
Vue.use(api)
Vue.use(user)
Vue.use(filters)
Vue.use(VueObserveVisibility)
Vue.use(VueScrollTo)
Vue.use(VueTimeago, {
  locale: 'de_at',
  locales: {
    'de_at': require('vue-timeago/locales/de-DE.json'),
    'de_de': require('vue-timeago/locales/de-DE.json'),
    // 'fr': require('vue-timeago/locales/fr-FR.json'),
    // 'hu': require('vue-timeago/locales/hu-HU.json'),
    'en': require('vue-timeago/locales/en-US.json')
  }
})

new Vue({
  api,
  i18n,
  components: {
    // ContentCarousel,
    // CarouselSlide,
    ContentTabs,
    ClientPageSearch,
    UserActions,
    RatingField,
    CommentList,
    TimesTimeline,
    LanguageSelect,
    PreferredLanguage,
    Adsense,

    NavbarDropdown,
    ClientMainMenu,
    ClientMainMenuNavbar,
    ClientMainMenuMobileToggle,
    ClientPanel,
    ClientPanelExpander,
    ClientPanelMobileToggle,
    ClientIngredientServingSelector,
    ClientIngredientList,
    ClientRecipeList,
    ClientInstructionItem,
    ClientInstructionStepByStep,
    ClientSearchList,
    ClientInfoMessage
  },
  data(){
    return {
      availableLanguages: []
    }
  }
}).$mount('#app')

window.api = api


document.addEventListener('lazyloaded', function(e){
  if(e.target.tagName === 'IMG'){
    e.target.parentNode.className = e.target.parentNode.className.replace('is-loading', '')
  }
})



// WEBPACK FOOTER //
// ./src/main.js